module.exports = __webpack_public_path__ + "assets/default-topic-bg.2fd581e6.svg";